export default (value, singular, plural, emptyWord = 'no') => {
  if (typeof singular === 'undefined' ||
    typeof plural === 'undefined') {
    throw new Error('Singular and plural terms are required.');
  }

  if (!value) {
    return `${ emptyWord } ${ plural }`;
  }

  return (value > 1) ? plural : singular;
};
